export default "print('hello world')\n"